import { useEffect, useState } from "react";

const useActiveSection = (sectionIds: string[], headerOffset = 96) => {
  const [activeSection, setActiveSection] = useState(sectionIds[0] ?? "");

  useEffect(() => {
    if (!sectionIds.length) {
      return undefined;
    }

    const updateActiveSection = () => {
      const scrollPosition = window.scrollY + headerOffset + 1;
      let nextActiveSection = sectionIds[0];

      sectionIds.forEach((sectionId) => {
        const element = document.getElementById(sectionId);

        if (element && element.offsetTop <= scrollPosition) {
          nextActiveSection = sectionId;
        }
      });

      setActiveSection(nextActiveSection);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("resize", updateActiveSection);

    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, [headerOffset, sectionIds]);

  return activeSection;
};

export default useActiveSection;
